import { default as time } from './time/services'
import { default as allocation } from  './allocation/services'
import { default as offer } from  './offer/services'
import { default as attribution } from  './attribution/services'
import { default as attributionResult } from  './attribution_result/services'
import { default as join } from  './join/services'
import { default as division } from  './division/services'

export default {
    ...time,
    ...allocation,
    ...offer,
    ...attribution,
    ...attributionResult,
    ...join,
    ...division
}